module.exports = __webpack_public_path__ + "static/media/subscribeDiscount1.c4d876c2.svg";